import React from 'react';
import ReactDOM from 'react-dom';
import "./Assets/flaticons/flaticon.css";
import "./Assets/stroke7/style.css";
import "./Theme/theme.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ErrorBoundary from './ErrorBoundary';
import configureStore from './redux/configureStore';
import { Provider as ReduxProvider } from 'react-redux';
import  { persistStore }  from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react';
import './index.scss';


const store = configureStore();
const persistor = persistStore(store);

ReactDOM.render(
  <ErrorBoundary>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor}>
          <App/>
      </PersistGate>
    </ReduxProvider>
  </ErrorBoundary>,
document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js